
import { defineComponent } from "vue";
import { useApiStore } from "@/stores/apiStore";
import { useSiteStore } from "@/stores/siteStore";
import { useImportStore } from "@/stores/importStore";
import moment from "moment-timezone";
import { FormatBytes } from "@/utils/Utilities";
import ImportFile from "@/utils/UploadHelper";

export default defineComponent({
	name: "imdex-upload-files",
	setup() {
		const api = useApiStore();
		const siteStore = useSiteStore();
		const importStore = useImportStore();
		const formatBytes = FormatBytes;
		return { api, moment, formatBytes, siteStore, importStore };
	},
	props: {
		filesToUpload: {
			type: Array,
			default: () => []
		},
		groupName: {
			type: String,
			default: ""
		},
		folderPath: {
			type: String,
			default: ""
		},
		datasetName: {
			type: String,
			default: ""
		}
	},
	data() {
		return {
			uploadingDone: false,
			fileStorage: [],
			uploadingFiles: [] as any,
			finishedFiles: [] as (string | object)[]
		};
	},
	mounted() {
		const c = this.filesToUpload.map((item: any) => {
			return { ...item };
		});
		this.uploadingFiles = c.map((item) => {
			return new ImportFile(
				item,
				this.datasetName,
				this.groupName,
				this.folderPath,
				this.api as any,
				(item: string | object) => this.finishedFiles.push(item),
				(this.siteStore as any).activeSite.id
			);
		});
		for (let i = 0; i < this.uploadingFiles.length; i++) {
			this.uploadingFiles[i].begin(i);
		}
	},
	methods: {
		cancelAll() {
			for (let i = 0; i < this.uploadingFiles.length; i++) {
				this.uploadingFiles[i].cancel();
				this.$emit("cancel");
			}
		}
	},
	computed: {
		uploadFinished() {
			const filesToBeUploaded = this.filesToUpload.map((item: any) => item.name);
			return this.finishedFiles.length == filesToBeUploaded.length;
		}
	},
	watch: {
		uploadFinished(v) {
			if (v) {
				let allUploadsGood = true;
				for (let i = 0; i < this.uploadingFiles.length; i++) {
					if ((this.uploadingFiles as any)[i].hasError) {
						allUploadsGood = false;
					}
				}
				if (allUploadsGood) {
					this.$emit("finished", this.uploadingFiles);
				}
			}
		}
	}
});
